package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the history area. */
interface HistoryStrings {
    val panelLabel: String

    val heading: String

    val collapse: String

    val emptyState: String

    val identityGuestTitle: String

    val identityGuestBody: String

    val identityCopyKey: String

    val identityCopied: String

    val identitySave: String

    val identitySaving: String

    fun identitySavedAs(email: String): String

    val untitled: String

    val cancel: String

    val delete: String

    fun versionCount(count: Int): String

    fun deleteLabel(title: String?): String

    fun confirmLabel(title: String): String

    fun deleteDetail(versions: Int): String

    val guestName: String
}

/** The history area in Spanish. */
internal object SpanishHistoryStrings : HistoryStrings {
    override val panelLabel: String = "Sesiones anteriores"

    override val heading: String = "Tus sesiones"

    override val collapse: String = "Contraer la lista de sesiones"

    override val emptyState: String = "Aquí aparecerán las páginas que pidas."

    override val identityGuestTitle: String = "Solo en este navegador"

    override val identityGuestBody: String = "Estas páginas están guardadas con una clave que vive aquí. Cópiala para recuperarlas en otro dispositivo, o déjame tu correo: te envío un enlace y, al abrirlo, quedan guardadas con él."

    override val identityCopyKey: String = "Copiar mi clave"

    override val identityCopied: String = "Clave copiada"

    override val identitySave: String = "Enviarme el enlace"

    override val identitySaving: String = "Enviando…"

    override fun identitySavedAs(email: String): String = "Guardadas con $email"

    override val untitled: String = "Sesión sin encargo"

    override val cancel: String = "Cancelar"

    override val delete: String = "Borrar"

    override fun versionCount(count: Int): String = when (count) {
        0 -> "sin páginas"
        1 -> "1 versión"
        else -> "$count versiones"
    }

    override fun deleteLabel(title: String?): String {
        val given = title ?: "sesión sin encargo"
        return "Borrar «$given»"
    }

    override fun confirmLabel(title: String): String = "Confirmar el borrado de «$title»"

    override fun deleteDetail(versions: Int): String = when (versions) {
        0 -> "Se borra. No se puede deshacer."
        1 -> "Se borra con su página. No se puede deshacer."
        else -> "Se borra con sus $versions páginas. No se puede deshacer."
    }

    override val guestName: String = "Sin correo"
}

/** The history area in English. */
internal object EnglishHistoryStrings : HistoryStrings {
    override val panelLabel: String = "Previous sessions"

    override val heading: String = "Your sessions"

    override val collapse: String = "Collapse the session list"

    override val emptyState: String = "The pages you ask for will show up here."

    override val identityGuestTitle: String = "Only in this browser"

    override val identityGuestBody: String = "These pages are kept under a key that lives here. Copy it to get them back on another device, or leave your email: I will send you a link and, once you open it, they are kept under that address."

    override val identityCopyKey: String = "Copy my key"

    override val identityCopied: String = "Key copied"

    override val identitySave: String = "Email me a link"

    override val identitySaving: String = "Sending…"

    override fun identitySavedAs(email: String): String = "Kept under $email"

    override val untitled: String = "Session with no request"

    override val cancel: String = "Cancel"

    override val delete: String = "Delete"

    override fun versionCount(count: Int): String = when (count) {
        0 -> "no pages"
        1 -> "1 version"
        else -> "$count versions"
    }

    override fun deleteLabel(title: String?): String {
        val given = title ?: "session with no request"
        return "Delete “$given”"
    }

    override fun confirmLabel(title: String): String = "Confirm deleting “$title”"

    override fun deleteDetail(versions: Int): String = when (versions) {
        0 -> "It gets deleted. This cannot be undone."
        1 -> "It gets deleted along with its page. This cannot be undone."
        else -> "It gets deleted along with its $versions pages. This cannot be undone."
    }

    override val guestName: String = "No email"
}
